import { createTheme } from "@mui/material";

export const theme = createTheme({
    components: {
        MuiInputLabel: {
            styleOverrides: {
                asterisk: {
                    color: 'red',
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                asterisk: {
                    color: 'red',
                },
            },
        },
    }
})
